import React, { Component } from 'react';
import MapComponent from '../../../InfluencerMap/Result/MapComponent/MapComponent';
import PrioritiesComponent from '../../../InfluencerMap/Result/PrioritiesComponent/PrioritiesComponent';
import _ from 'lodash';

class Tabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            review1: '',
            review2: '',
        };
    }
    onChange = (name, value) => {
        if (name === "review1") {
            this.setState({
                review1: value
            })
        }
        if (name === "review2") {
            this.setState({
                review2: value
            })
        }
    }
    onAddReview1 = (groupId, segmentId) => {
        if (this.state.review1 !== '') {
            this.props.onAddPlace(groupId, segmentId, "review1", this.state.review1)
            this.setState({ review1: '' })
        }
    }
    onAddReview2 = (groupId, segmentId) => {
        if (this.state.review2 !== '') {
            this.props.onAddPlace(groupId, segmentId, "review2", this.state.review2)
            this.setState({ review2: '' })
        }
    }
    render() {
        let tabs = []
        this.props.tabs.map((item, key) => {
            this.props.compete.customerSegmentData.map(comp => {
                comp.segments.map(segments => {
                    if (item.groupId === comp.groupId && item.segmentId === segments.segmentId) {
                        tabs.push(
                            <li className="nav-item" key={`${item.groupId + `id` + item.segmentId}`} onClick={()=>this.props.onTabChange(key)}>
                                <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" : "nav-link"} href={`#${item.groupId + `id` + item.segmentId}`} aria-controls={`${item.groupId + `id` + item.segmentId}`} aria-selected="true">{comp.groupName + ` - ` + segments.name}</a>
                            </li>)
                    }
                })
            })

        });
        let tabsContent = this.props.tabs.map((tabItem, key) => {
            return (
                <div id={tabItem.groupId + `id` + tabItem.segmentId} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv positioning-tab-content" : "tab-pane fade tabContentdiv compete-tab-content positioning-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                            Review your influencer map. Thinking about this segment, is there a change about where or through
                                            which channels you will make your product available? E.g., any new distribution channels that are
                                            appropriate for reaching this segment?
                                        </div>
                                        <div className="col-md-11">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.review1}
                                                    onChange={(e) => this.onChange('review1', e.target.value)}
                                                    onKeyPress={(e) => { e.key === "Enter" && this.onAddReview1(tabItem.groupId, tabItem.segmentId) }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <i className="fa fa-plus plusbtn plus-icon" onClick={() => { this.onAddReview1(tabItem.groupId, tabItem.segmentId) }}></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    {tabItem.place && tabItem.place.review1 && tabItem.place.review1.length > 0 &&
                                        tabItem.place.review1.map((review, key) => {
                                            return <div key={key} className="promotionValues">
                                                <label >{review}</label>
                                                <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeleteReview1(tabItem.groupId, tabItem.segmentId, review)}></i>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                            <div className="col-md-12" style={{border: "1px solid #ddd"}}></div>
                            <div className="row" style={{marginTop: "25px"}}>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-12">
                                            Again, reviewing your influencer map, should there be a change in who sells your product/service or
                                            how the message is delivered? E.g., do you need a new sales force set of skills – or new personnel – to
                                            be effective in reaching this influencer group and segment? Do you need new direct marketing skills
                                            that the organization doesn’t currently posses?
                                        </div>
                                        <div className="col-md-11" style={{ marginTop: "15px" }}>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.review2}
                                                    onChange={(e) => this.onChange('review2', e.target.value)}
                                                    onKeyPress={(e) => { e.key === "Enter" && this.onAddReview2(tabItem.groupId, tabItem.segmentId) }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-1" style={{ marginTop: "15px" }}>
                                            <i className="fa fa-plus plusbtn plus-icon" onClick={() => { this.onAddReview2(tabItem.groupId, tabItem.segmentId) }}></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    {tabItem.place && tabItem.place.review2 && tabItem.place.review2.length > 0 &&
                                        tabItem.place.review2.map((review, key) => {
                                            return <div key={key} className="promotionValues">
                                                <label >{review}</label>
                                                <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeleteReview2(tabItem.groupId, tabItem.segmentId, review)}></i>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12">
                            <div className='row' style={{borderTop: "1px solid #ddd"}}>
                                <div className="col-sm-12">
                                    <h5 style={{marginTop: "10px"}}>Influencer Map</h5>
                                </div>
                                {/* <div className='col-sm-2'> */}
                                    {this.props.getInfluencerMapGroupsData.Items && this.props.getInfluencerMapGroupsData.Items[0].priorities &&
                                        <PrioritiesComponent
                                            getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                        />
                                    }
                                {/* </div> */}
                                {/* <div className='col-sm-10'> */}
                                    <div className='canvas-card'>
                                        <div className='canvas-content' id="banner-contenedor">
                                            {!_.isEmpty(this.props.getInfluencerMapGroupsData) &&
                                                <MapComponent
                                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                                />
                                            }
                                        </div>
                                    </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )

        })
        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    {tabs}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}

export default (Tabs);



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/Step3/Tabs/Tabs.jsx